import * as React from "react";
const SvgKeyboardBackspace = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 19L2 12L9 5L10.4 6.4L5.825 11H22V13H5.825L10.425 17.6L9 19Z" }));
export default SvgKeyboardBackspace;
